import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { withUAPLThemedStyles } from '@bingads-webui-campaign-react/unified-ad-preview-library-core';

import { getPlacementCardStyles } from '../styles';

const PlacementCardImpl = ({
  url,
  children,
  placementCardClassName,
  isClickDisabled,
  classes,
}) => (
  <div
    className={classnames(
      classes.placementCardRoot,
      placementCardClassName,
      'ad-placement-card-preview'
    )}
  >
    <div className="card-parent">
      {url && !isClickDisabled ? (
        <a
          className="placement-card-content"
          target="_blank"
          rel="noopener noreferrer"
          href={url}
        >
          {children}
        </a>
      ) : (
        <div className="placement-card-content">{children}</div>
      )}
    </div>
  </div>
);
PlacementCardImpl.propTypes = {
  url: PropTypes.string,
  children: PropTypes.node.isRequired,
  placementCardClassName: PropTypes.string,
  isClickDisabled: PropTypes.bool,
  classes: PropTypes.shape({
    placementCardRoot: PropTypes.string,
  }).isRequired,
};

PlacementCardImpl.defaultProps = {
  url: undefined,
  placementCardClassName: undefined,
  isClickDisabled: true, // default to disable click
};

export const PlacementCard = withUAPLThemedStyles(
  PlacementCardImpl,
  getPlacementCardStyles,
  { componentName: 'PlacementCard ' }
);
